import React from 'react'
import VBEventMatch from '../components/VBEventMatch'

const PublicVBEventMatchView = ({ match }) => {
  return <VBEventMatch isPublic={true} vbMatchId={match.params.id} />
}

export default PublicVBEventMatchView
